import { createFileRoute } from '@tanstack/react-router';
import { AlternativesIndexPage } from '../../../pages/alternatives/AlternativesIndexPage';
import { CATALOG_API_COUNT } from '../../../lib/catalogSize';
import { staticPageHead } from '../../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/alternatives/')({
  head: () =>
    staticPageHead({
      path: '/alternatives',
      title: 'API alternatives: honest, tested tool comparisons',
      description:
        `Tested comparisons against the tools you already use. One key, one wallet, priced in dollars, with ${CATALOG_API_COUNT} APIs behind it. From the AnyAPI gateway.`,
      crumb: 'Alternatives',
      og: { title: 'API alternatives', type: 'website' },
    }),
  component: () => <AlternativesIndexPage />,
});
